export default "__VITE_ASSET__kcSinJ$w__"